import React from "react"

const MoreButtonArrowIcon = () => {
  return (
    <svg
      width="25"
      height="12"
      viewBox="0 0 25 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.5492 5.33639C24.549 5.33611 24.5487 5.33578 24.5484 5.3355L19.6498 0.460497C19.2828 0.0952938 18.6892 0.0966529 18.3239 0.463684C17.9587 0.830668 17.9601 1.42425 18.3271 1.7895L21.616 5.0625H1.76172C1.24394 5.0625 0.824219 5.48221 0.824219 6C0.824219 6.51778 1.24394 6.9375 1.76172 6.9375H21.616L18.3271 10.2105C17.9601 10.5757 17.9587 11.1693 18.324 11.5363C18.6893 11.9034 19.2829 11.9047 19.6498 11.5395L24.5485 6.6645C24.5487 6.66421 24.549 6.66389 24.5493 6.66361C24.9165 6.29714 24.9153 5.70164 24.5492 5.33639Z"
        fill="black"
      />
    </svg>
  )
}
export default MoreButtonArrowIcon
